module.exports = __webpack_public_path__ + "img/defaultProductIco.96a2eea4.png";